// localStorage keys
const PENDING_KEY = 'alarm_pending_logs';
const SCHEDULED_KEY = 'alarm_scheduled_map';

// --------------- Pending delivery/action logs ---------------
// Shape: { [alarmId_YYYY-MM-DD]: { alarm_id, log_date, delivery_status, user_action_status, fired_at } }

export function getPendingLogs() {
  try {
    return JSON.parse(localStorage.getItem(PENDING_KEY) || '{}');
  } catch {
    return {};
  }
}

export function hasPendingLogs() {
  return Object.keys(getPendingLogs()).length > 0;
}

// Upsert a log entry keyed by alarm_id + log_date so each day gets its own entry.
// data must include log_date (YYYY-MM-DD); falls back to today if omitted.
export function savePendingLog(alarmId, data) {
  const logDate = data.log_date || new Date().toISOString().slice(0, 10);
  const key = `${alarmId}_${logDate}`;
  const logs = getPendingLogs();

  logs[key] = { alarm_id: alarmId, ...logs[key], ...data, log_date: logDate };
  localStorage.setItem(PENDING_KEY, JSON.stringify(logs));
}

export function clearPendingLogs() {
  localStorage.removeItem(PENDING_KEY);
}

// --------------- Scheduled notifications map ---------------
// Shape: { [notificationId]: { alarm_id, fire_at (ISO string) } }
// Saved when alarms are scheduled so we can detect which ones fired while app was closed.

export function getScheduledMap() {
  try {
    return JSON.parse(localStorage.getItem(SCHEDULED_KEY) || '{}');
  } catch {
    return {};
  }
}

export function saveScheduledMap(map) {
  localStorage.setItem(SCHEDULED_KEY, JSON.stringify(map));
}

// Remove entries whose fire_at is in the past (already processed)
export function pruneScheduledMap(pendingIds) {
  const map = getScheduledMap();
  const pending = new Set(pendingIds.map(String));
  const now = Date.now();
  const pruned = {};

  for (const [notifId, entry] of Object.entries(map)) {
    const fireAt = new Date(entry.fire_at).getTime();

    // Keep if still pending OR if fire time is in the future
    if (pending.has(notifId) || fireAt > now) {
      pruned[notifId] = entry;
    }
  }

  localStorage.setItem(SCHEDULED_KEY, JSON.stringify(pruned));

  return pruned;
}
